import type { Locale } from '../types';

export const terminologyDictionary = {
  en: {
    'term.country.philippines': 'Philippines',
    'term.installer.singular': 'solar installer',
    'term.installer.plural': 'solar installers',
    'term.solarSystem': 'solar system',
    'term.systemDetails': 'system details',
    'term.systemSize': 'system size',
    'term.panel.singular': 'panel',
    'term.panel.plural': 'panels',
    'term.approxPanels': 'Approximately {count} panels',
    'term.locationForInstallerSearch': 'Location used to find installers',
    'term.cityMatching': 'city-level matching',
    'term.regionMatching': 'regional matching',
    'term.sourceConfidence.high': 'High public-source confidence',
    'term.sourceConfidence.medium': 'Medium public-source confidence',
    'term.sourceConfidence.low': 'Limited public-source confidence',
    'term.daytimeUse': 'daytime electricity use',
    'term.roofLayout': 'roof layout',
    'term.roofStructure': 'roof structure',
    'term.installedCostRange': 'installed-cost range',
    'term.targetReduction': 'target bill reduction',
    'term.monthAverage': 'monthly average',
    'term.projectDetails': 'project details',
    'term.gridTied': 'grid-tied',
    'term.hybrid': 'hybrid',
    'term.offGrid': 'off-grid',
  },
} as const;

export type TerminologyKey = keyof (typeof terminologyDictionary)['en'];

export function terminology(
  _locale: Locale,
  key: TerminologyKey,
  values?: Record<string, string | number>,
) {
  let text: string = terminologyDictionary.en[key];
  for (const [name, value] of Object.entries(values ?? {})) {
    text = text.replaceAll(`{${name}}`, String(value));
  }
  return text;
}
